import React, { useMemo } from 'react'
import styled from 'styled-components'
import Pane from 'components/Common/Pane'
import Group from 'components/utils/Group'
import uuidV4 from 'lib/string/uuidV4Utils'
import useQueryParams from 'hooks/useQueryParams'
import BedbankRoomOptionRate from '../../BedbankRoomOptionRate'

const PackagesContainer = styled(Group)`
  background-color: ${props => props.theme.palette.neutral.default.six};
`

interface Props {
  offer: App.BedbankOffer;
  packageView: App.BedbankOfferPackageView;
  roomPosition: number;
}

function BedbankPackageOptionsModalTab(props: Props) {
  const { offer, packageView, roomPosition } = props

  const query = useQueryParams()
  const source = query.get('source') ?? undefined

  const roomListId = useMemo(() => uuidV4(),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [packageView])

  const rateListId = useMemo(() => uuidV4(),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [packageView.rates])

  return (
    <PackagesContainer direction="vertical" gap={16}>
      {packageView.rates.map((rate, index) => <Pane key={rate.id}>
        <BedbankRoomOptionRate
          key={rate.id}
          rate={rate}
          offer={offer}
          roomListId={roomListId}
          packageView={packageView}
          optionNumber={index + 1}
          rateListId={rateListId}
          roomPosition={Math.max(roomPosition, 0) + 1}
          source={source}
        />
      </Pane>)}
    </PackagesContainer>
  )
}

export default BedbankPackageOptionsModalTab
